import { type DynamicImportComponentDetail } from 'hb-builder/types';

const getComponentsExcludedInPageEvent = (): Array<DynamicImportComponentDetail> => [
  // Advanced Components
  { name: 'Slider' },
  { name: 'List' },
  {
    name: 'Publication',
  },

  // New block components
  { name: 'Partners' },
  { name: 'Partner' },
  {
    label: 'PartnersTemplateOne',
    name: 'TemplateOne',
  },
  {
    label: 'PartnersTemplateTwo',
    name: 'TemplateTwo',
  },
  {
    name: 'PartnersSlider',
  },
  {
    label: 'PartnersTemplateFour',
    name: 'TemplateFour',
  },
  {
    name: 'PartnersShifted',
  },
  { name: 'PartnersGrid' },
  {
    label: 'PartnersTemplateThree',
    name: 'TemplateThree',
  },
  {
    name: 'Strips',
  },
  {
    name: 'StripsSlider',
  },
  {
    label: 'StripsTemplateWithButton',
    name: 'TemplateWithButton',
  },
  {
    name: 'TemplateWithButtonStripsItem',
  },
  {
    label: 'StripsTemplateWithPlainImages',
    name: 'TemplateWithPlainImages',
  },
  {
    name: 'TemplateWithPlainImagesStripsItem',
  },
  {
    label: 'StripsTemplateWithLongText',
    name: 'TemplateWithLongText',
  },
  {
    name: 'TemplateWithLongTextStripsItem',
  },
  {
    label: 'ImageGalleries',
    name: 'Gallery',
  },
  {
    name: 'GalleryTemplateGrid',
  },
  {
    name: 'GridItem',
  },
  {
    name: 'GalleryTemplateSlider',
  },
  {
    name: 'SliderItem',
  },
  {
    name: 'GalleryTemplateBigSlider',
  },
  {
    name: 'InfiniteSlider',
  },
  {
    name: 'UserBanner',
  },
];

export const getPageComponentsList = ({
  isPageEvent,
}: {
  isPageEvent?: boolean;
} = {}): Array<DynamicImportComponentDetail> =>
  [
    { name: 'Body' },
    {
      name: 'Headline',
    },
    {
      name: 'Text',
    },
    {
      name: 'Button',
    },
    {
      name: 'Buttons',
    },
    { name: 'Column' },
    { name: 'Divider' },
    {
      name: 'DroppableLastBlock',
    },
    {
      name: 'EmptyDocumentPlaceholder',
    },
    {
      name: 'Hero',
    },
    { name: 'Html' },
    { name: 'PageImage' },
    { name: 'Root' },
    { name: 'Spacer' },
    { name: 'Section' },

    { name: 'Wrapper' },
    { name: 'Video' },
    {
      name: 'HeroSlider',
    },
    {
      name: 'Slide',
    },

    // Empty Structures
    { name: 'HalfWidth' },
    { name: 'FullWidth' },
    { name: 'OneTwoThird' },
    { name: 'TwoOneThird' },
    { name: 'ThreeColumns' },
    { name: 'FourColumns' },

    // Predefined Structures
    {
      name: 'TwoColumnsAltImageText',
    },
    {
      name: 'TwoColumnsImages',
    },
    {
      name: 'TwoColumnsImageText',
    },
    {
      name: 'ThreeColumnsImageText',
    },
    {
      name: 'FourColumnsAltImageText',
    },
    {
      name: 'FourColumnsImageText',
    },
    ...(!isPageEvent ? getComponentsExcludedInPageEvent() : []),
  ].filter(Boolean);
